<template>
	<div class="MyHome">
		<div class="header">
			<rs-row>
				<rs-col :span="24">
					<div class="grid-content bg-purple-dark">我的用户</div>
				</rs-col>
			</rs-row>
		</div>
		<div class="main">
			<div class="main_header">
				<rs-form style="margin-left: 20px; margin-top: 20px;width: 100%;" size="mini " :inline="true"
					class="demo-form-inline">
					<rs-form-item label="姓名：">
						<rs-input style="width: 100%;" v-model="searchForm.contactName" placeholder="请输入姓名"></rs-input>
					</rs-form-item>
					<rs-form-item label="手机号：">
						<rs-input style="width: 100%;" v-model="searchForm.contactNumber" placeholder="请输入手机号">
						</rs-input>
					</rs-form-item>
					<rs-form-item>
						<rs-button type="primary" @click="show">查询</rs-button>
						<rs-button @click="clear">重置</rs-button>
					</rs-form-item>
				</rs-form>
			</div>
			<div class="main_main">
				<rs-button style="margin-left: 20px" type="primary" @click="add">新增用户</rs-button>
				<rs-table v-loading.fullscreen.lock="fullscreenLoading" highlight-current-row
					style="margin-top: 10px; box-sizing: border-box; " border :data="tableData">
					<rs-table-column show-overflow-tooltip align='center' label="序号" type="index" header-align='center'>
					</rs-table-column>
					<rs-table-column show-overflow-tooltip align="center" label="登录用户名" prop="userCode"
						header-align='center'>
					</rs-table-column>
					<rs-table-column show-overflow-tooltip align="center" label="真实姓名" prop="contactName"
						header-align='center'>
					</rs-table-column>
					<rs-table-column label="手机号" show-overflow-tooltip align="center" prop="contactNumber"
						header-align='center'>
					</rs-table-column>
					<!-- <rs-table-column label="最后登录的IP地址" show-overflow-tooltip aligin="center" width="180" prop="IP" header-align='center'>
					</rs-table-column>
					<rs-table-column show-overflow-tooltip aligin="center" label="登录次数" width="100" prop="num" header-align='center'>
					</rs-table-column> -->
					<rs-table-column show-overflow-tooltip align="center" label="状态" header-align='center'
						prop="accountStatus" :formatter="formatCarModels">
					</rs-table-column>
					<rs-table-column label="更新时间" header-align='center' show-overflow-tooltip align="center"
						prop="modifyTime">
					</rs-table-column>
					<rs-table-column fixed="right" label="操作" header-align='center' width='250' align="center">
						<template slot-scope="scope">
							<rs-button size="mini" type="primary" plain @click="hadel(scope.$index, scope.row)">编辑
							</rs-button>
							<rs-button size="mini"  plain
								@click="update(scope.$index, scope.row,ruleForm)">修改密码
							</rs-button>
							<rs-button size="mini" v-if='lnke' :disabled="scope.row.accountType ==0" plain type="danger"
								@click="handleDelete(scope.$index, scope.row)">禁用
							</rs-button>
							<rs-button size="mini" v-if='lonk' :disabled="scope.row.accountType ==0" plain
								type="success" @click="handleEnable(scope.$index, scope.row)">启用
							</rs-button>
						</template>
					</rs-table-column>
				</rs-table>
				<!-- 分页 -->
				<rs-pagination style="padding: 20px;" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 200, 300, 400]"
					:page-size="pageSize" background :prev-text="'上一页'" :next-text="'下一页'"
					layout="total,prev, pager, next, sizes, jumper" :total="total"></rs-pagination>
			</div>
		</div>

		<!-- 新增用户 -->
		<rs-dialog title="新增用户" width='30%' top='20vh' :close-on-click-modal="false" :visible.sync="dialogFormVisible"  :modal-append-to-body="false">
			<rs-form :model="lists" status-icon :rules="rules">
				<!-- <rs-form-item label="用户名:"  :label-width="formLabelWidth">
					<rs-input ref="name" v-model="userName" placeholder="请输入用户名" autocomplete="off"></rs-input>
				</rs-form-item> -->
				<!-- <rs-form-item label="密码:" :rules="{
            required: true,
            message: '密码不能为空',
            trigger: 'blur',
          }" :label-width="formLabelWidth">
					<rs-input show-password ref="pwd" v-model="passWord" placeholder="最少输入8位含字母数字的字符"
						autocomplete="off"></rs-input>
				</rs-form-item> -->
				<rs-form-item label="姓名:" :label-width="formLabelWidth"  prop='name'>
					<rs-input style="width: 80%;" ref="name" v-model="lists.name" placeholder="请输入姓名" autocomplete="off">
					</rs-input>
				</rs-form-item>
				<rs-form-item label="联系方式:" prop='Phone' :label-width="formLabelWidth" >
					<rs-input style="width: 80%;" ref="pwd"  show-word-limit maxlength="11" v-model.number="lists.Phone" placeholder="请输入联系方式"
						autocomplete="off"></rs-input>
				</rs-form-item>
			</rs-form>
			<div slot="footer" class="dialog-footer">
				<rs-button @click="dialogFormVisible = false">取 消</rs-button>
				<rs-button type="primary" @click="clearIN">重 置</rs-button>
				<rs-button type="primary" @click="onSumit">提 交</rs-button>
			</div>
		</rs-dialog>
		<rs-dialog title='修改密码' :close-on-click-modal="false" width='30%' height='50vh' top="20vh" :visible.sync="dialogFormVisibless"  :modal-append-to-body="false">
			<rs-form :model="ruleForm" status-icon :rules="rules1" ref="ruleForm" class="demo-ruleForm">
				<rs-form-item label="新密码" :label-width="formLabelWidth" prop="pass">
					<rs-input style="width: 80%;" type="password" placeholder="请输入密码" v-model="ruleForm.pass"
						show-password autocomplete="off"></rs-input>
					<!-- <rs-progress :percentage="passwordPercent" :format="passwordPercentFormat"></rs-progress> -->
				</rs-form-item>
				<rs-form-item label="确认密码" prop="checkPass" style='margin-top: 30px;' :label-width="formLabelWidth">
					<rs-input style="width: 80%;" type="password" placeholder="请输入密码" show-password
						v-model="ruleForm.checkPass" autocomplete="off"></rs-input>
				</rs-form-item>
			</rs-form>
			<div slot="footer" class="dialog-footer">
				<rs-button @click="passcan">取 消</rs-button>
				<rs-button type="primary" @click="submitForm('ruleForm')">提交</rs-button>
				<rs-button @click="resetForm('ruleForm')">重置</rs-button>
			</div>
		</rs-dialog>
		<!-- 编辑用户 -->
		<rs-dialog title="编辑用户" width='30%' top='20vh' :visible.sync="dialogFormVisibles"  :modal-append-to-body="false">
			<rs-form :model="form" :hide-required-asterisk="false" :rules='ruless'>
				<!-- <rs-form-item label="用户名:" prop='userCode'  :label-width="formLabelWidth">
					<rs-input :disabled="true" v-model='form.userCode'   placeholder="请输入" autocomplete="off"></rs-input>
				</rs-form-item>
				<rs-form-item v-if='number!==""'   ref='ll' label="是否修改密码:" :label-width="formLabelWidth">
					<rs-switch id='ll' disabled  v-model="dire" @change="change"></rs-switch>
				</rs-form-item>
				<rs-form-item v-else   ref='ll' label="是否修改密码:" :label-width="formLabelWidth">
					<rs-switch id='ll'   v-model="dire" @change="change"></rs-switch>
				</rs-form-item>
				<rs-form-item label="新密码:" :rules="{
            required: true,
            message: '密码不能为空',
            trigger: 'blur',
          }" :label-width="formLabelWidth" v-if="link">
					<rs-input show-password v-model="password" placeholder="最少输入8位含字母数字的字符" autocomplete="off">
					</rs-input>
				</rs-form-item>
				<rs-form-item  label="确认密码:" :label-width="formLabelWidth" v-if="link" :rules="{
            required: true,
            message: '密码不能为空',
            trigger: 'blur',
          }">
					<rs-input show-password v-model="password1" placeholder="最少输入8位含字母数字的字符" autocomplete="off">
					</rs-input>
				</rs-form-item> -->
				<rs-form-item prop='contactName' label="姓名:" :label-width="formLabelWidth">
					<rs-input style="width: 80%;" v-model='form.contactName' placeholder="请输入姓名" autocomplete="off">
					</rs-input>
				</rs-form-item>
				<rs-form-item prop='contactNumber' label="联系方式:" :label-width="formLabelWidth">
					<rs-input style="width: 80%;" show-word-limit maxlength="11" v-model='form.contactNumber' placeholder="请输入联系方式" autocomplete="off">
					</rs-input>
				</rs-form-item>

			</rs-form>
			<div slot="footer" class="dialog-footer">
				<rs-button @click="can">取 消</rs-button>
				<rs-button type="primary" @click="clearout">重 置</rs-button>
				<rs-button type="primary" @click="hadell">提 交</rs-button>
			</div>
		</rs-dialog>
	</div>
</template>
<script>
	import API from "@/api/pay";
	import Until from "../../../utils/utils";
	import api from "../../../api/api";
	export default {
		data() {

			var validatePass = (rule, value, callback) => {
				const reg = /^(?=.*?[0-9a-zA-Z])(?=.*?[0-9a-zA-Z])[0-9a-zA-Z]{8,}$/; //mima123456
				//       if (value === '') {
				//         callback(new Error('请输入密码'));
				//       }else if(!reg.test(value)){
				// 	 callback(new Error('密码格式输入错误'));
				// } else {
				//         if (this.ruleForm.checkPass !== '') {
				//           this.$refs.ruleForm.validateField('checkPass');
				//         }
				//         callback();
				//       }
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					//6-20位包含字符、数字和特殊字符
					var ls = 0;
					if (value !== '') {
						if (value.match(/([a-z])+/)) {
							ls++;
						}
						if (value.match(/([0-9])+/)) {
							ls++;
						}
						if (value.match(/([A-Z])+/)) {
							ls++;
						}
						if (value.match(/([\W])+/) && !value.match(/(![\u4E00-\u9FA5])+/)) {
							ls++;
						}
						if (value.length < 6 || value.length > 20) {
							callback(new Error('要求6-20位字符'));
							ls = 0;
						}
						if (value.match(/([\u4E00-\u9FA5])+/)) {
							callback(new Error('不能包含中文字符'));
							ls = 0;
						}
						switch (ls) {
							case 0:
								this.passwordPercent = 0;
								callback(new Error('请至少输入6位字符数字、字母(大小写必须存在）的字符'));
								break;
							case 1:
								this.passwordPercent = 33;
								callback(new Error('请至少输入6位字符数字、字母(大小写必须存在）的字符'));
								break;
							case 2:
								this.passwordPercent = 66;
								callback(new Error('请至少输入6位字符数字、字母(大小写必须存在）的字符'));
								break;
							case 3:
							case 4:
								this.passwordPercent = 100;
								break;
							default:
								this.passwordPercent = 0;
								break;
						}
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				passwordPercent: 0,
				ruleForm: {
					pass: '',
					checkPass: '',

				},
				ruless:{
					contactName:[{
						required:true,message:'姓名不能为空',trigger: 'blur',
					}],
					contactNumber:[{
						required:true,message:'手机号不能为空',trigger: 'blur',
					},
					 { pattern:/(1[3-9]\d{9}$)/, message: '输入的联系电话有误', trigger: 'blur' }
					]
				},
				rules:{
					name:[{
						required:true,message:'姓名不能为空',trigger: 'blur',
					}],
					Phone:[{
						required:true,message:'手机号不能为空',trigger: 'blur',
					},
					 { pattern:/(1[3-9]\d{9}$)/, message: '输入的联系电话有误', trigger: 'blur' }
					]
				},
				rules1: {
					pass: [{
						validator: validatePass,
						trigger: 'blur',
						required: true
					}],
					checkPass: [{
						validator: validatePass2,
						trigger: 'blur',
						required: true
					}]
				},
				fullscreenLoading: false,
				disableds: false,
				searchForm: {
					contactName: '',
					contactNumber: ''
				},
				checked: true,
				password: "",
				password1: "",
				dire: false,
				link: false,
				form: {
					userCode: '',
					contactName: '',
					contactNumber: '',
					accountStatus: '',
					id: ''
				},
				lists:{
					name: "",
					Phone: "",
				},
				formLabelWidth: "120px",
				pageNum: 1,
				pageSize: 10,
				total: 0,
				username: "",
				
				phone: "",
				userName: "",
				passWord: "",
				
				dialogFormVisible: false,
				dialogFormVisibles: false,
				dialogFormVisibless: false,
				tableData: [],
				list: [],
				staticId: "",
				listUser: [],
				accountStatus: 0,
				phones: [],
				number: '',
				aa: [],
				id: '',
				passId: '',
				contactNumber: '',
				contactName: ''
			};
		},
		created() {
			if(this.dialogFormVisibless==false){
				this.ruleForm.pass==' '
				this.ruleForm.checkPass==' '
			}
			this.bus.$on("sendId", (id) => {
				this.staticId = id
				console.log(this.staticId);
			});
			this.bus.$on("id", (id) => {
				this.passId = id
				console.log(this.passId);
			});
			this.bus.$on("contactName", (id) => {
				this.contactName = id
				console.log(this.contactName);
			});
			this.bus.$on("contactNumber", (id) => {
				this.contactNumber = id
				console.log(this.contactNumber);
			});
			this.getlist();

		},
		mounted() {
			// console.log(this.$get('status'))
		},
		computed: {

		},
		methods: {
			// open(formName){
			// 	this.$refs[formName].resetFields();
			// },
			changestk(val) {
				if (val == '0') {
					console.log(this.accountStatus)

				} else {

					console.log(this.accountStatus)
				}
			},
			can() {
				this.dialogFormVisibles = false,
					this.getlist()
			},
			passcan() {
				this.$emit('hidePassword', false)
				setTimeout(() => {
				  this.resetForm('ruleForm')
				})
				// this.ruleForm.pass='',
				this.ruleForm.checkPass=''
				this.dialogFormVisibless = false,
					this.getlist()
			},
			onChange(e) {
				this.checked = e.target.checked
				this.$emit('change', e.target.checked)
				console.log(e)
			},
			passwordPercentFormat(percentage) {
				return percentage == 100 ? '符合' : `不符`;
			},
			formatCarModels(row, Status) {
				if (row.accountStatus == "0") {
					this.lnke = true
					this.lonk = false
					return "正常";
				} else if (row.accountStatus == '1') {
					this.lnke = false
					this.lonk = true
					return "禁用";
				}
			},
			//获取列表
			getlist() {
				this.fullscreenLoading = true;
				setTimeout(() => {
					this.fullscreenLoading = false;
				}, 2000);
				let userName = Until.getSession("pay").userName;
				let phone = Until.getSession("shopVo");

				let params = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					lesseeId: phone,
					...this.searchForm
				};
				API.investLesseeAccountlist(params).then((res) => {
					if (res.data.code == 200) {
						this.tableData = res.data.data.records;
						this.total = res.data.data.totalRecords;
						console.log(res.data.data.records)
					}
				});
			},
			handleSizeChange(val) {
				console.log(val);
				this.pageSize = val
				this.getlist();
			},
			handleCurrentChange(val) {
				console.log(val)
				this.pageNum = val;
				this.getlist();
			},
			//重置
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			clearIN() {
				// (this.userName = ""),
				// (this.passWord = ""),
				(this.lists.name = ""),
				(this.lists.Phone = "");
			},
			clearout() {
				(this.password = ""),
				(this.password1 = ""),
				(this.form.contactName = ""),
				(this.form.account = "");
				this.form.contactNumber = ''
				this.getlist()
			},
			clear() {
				this.searchForm = {
					contactName: '',
					contactNumber: ''
				}
			},
			//搜索
			show() {
				this.getlist()
			},
			//修改密码
			change() {
				if (this.dire == true) {
					this.link = true;
					var num = 1
					this.bus.$emit('num', num)
					console.log(num)
				} else {
					this.link = false;
				}
			},
			//禁用用户
			handleDelete(index, rows) {
				console.log(rows.userCode);
				this.$confirm("您确认要禁用吗?")
					.then((success) => {
						let params = {
							id: rows.id,
							accountStatus: 1,
							userCode: rows.userCode
						}
						console.log(params)
						API.delLessAccount(params).then((res) => {
							if (res.data.code = 200) {
								this.$message({
									type: 'success',
									message: '禁用成功'
								})
								console.log(res)
								this.getlist()
							}
						})
					})
					.catch((err) => {
						console.log(err);
					});
			},
			//启用
			handleEnable(index, row) {
				let params = {
					id: row.id,
					accountStatus: 0,
				}
				console.log(params)
				API.delLessAccount(params).then((res) => {
					if (res.data.code = 200) {
						this.$message({
							type: 'success',
							message: '启用成功'
						})
						console.log(res)
						this.getlist()
					}
				})
			},
			//新增用户
			add() {
				this.userName = "",
					this.passWord = "",
					this.name = "",
					this.Phone = ""
				// this.form = {};
				this.dialogFormVisible = true;
			},
			onSumit() {
				const reg = /^(?=.*?[0-9])(?=.*?[a-z])[0-9a-zA-Z]{8,}$/; //mima123456
				const tel = /(1[3-9]\d{9}$)/;
				if (this.lists.name == "") {
					console.log(this.form);
					this.$message.error(
						"姓名不能为空",
					);
					this.$refs.name.$el.style.border = "1px solid red";
				} else if (!tel.test(this.lists.Phone)) {
					this.$message.error('手机号格式不正确')
				} else {
					this.$refs.pwd.$el.style.border = "none";
					this.$refs.name.$el.style.border = "none";
					this.$refs.pwd.$el.style.border = "none";
					this.dialogFormVisible = false;
					let lesseeId = sessionStorage.getItem("shopVo");
					let params = {
						contactNumber: this.lists.Phone,
						contactName: this.lists.name,
						lesseeId: lesseeId
					};
					//新增账号
					API.addcreateOrEditLesseeAccount(params).then((res) => {
						console.log(res);
						this.getlist()
					});
					this.userName = "",
						this.password = "",
						this.lists.name = "",
						this.lists.Phone = ""
				}
			},
			//修改密码
			update(index, row) {
				console.log(row)
				this.ruleForm.pass = ''
				this.ruleForm.checkPass = ''
				// this.$refs[formName].resetFields();
				this.dialogFormVisibless = true
				let id = row.id
				this.bus.$emit("id", id);
				this.bus.$emit("contactName", row.contactName);
				this.bus.$emit("contactNumber", row.contactNumber);
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let params = {
							id: this.passId,
							contactNumber: this.contactNumber,
							contactName: this.contactName,
							password:this.ruleForm.pass
						}
						API.unpdatePassword(params).then((res) => {
							if (res.data.code == 200) {
								console.log(res)
								this.$message({
									message: '修改密码成功',
									type: 'success'
								})
								this.dialogFormVisibless = false
								this.getlist()
								this.$refs[formName].resetFields();
								this.ruleForm.pass='',
								this.ruleForm.checkPass=''
									this.passwordPercent = 0
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			//编辑用户
			hadel(index, row) {
				this.idx = index;
				this.id = row.id;
				// console.log(this.id)
				this.bus.$emit("sendId", this.id);
				this.form.userCode = row.userCode;
				this.form.contactName = row.contactName;
				this.form.contactNumber = row.contactNumber
				this.form.accountStatus = Number(row.accountStatus)
				this.form.id = row.id
				console.log(typeof Number(this.form.accountStatus));
				this.dialogFormVisibles = true;

				// localStorage.setItem('id',row.id)
			},
			hadell() {
				console.log(localStorage.getItem('id') !== this.staticId)
				this.number = this.password
				// if(this.number!==""){
				// 	this.link=false,
				// 	this.dire=false
				// }
				let lesseeId = sessionStorage.getItem("shopVo");
				// console.log(!reg.test(this.password))
				// if (this.dire == true) {
				// 	console.log(this.password)
				// 		const reg = /^(?=.*?[0-9])(?=.*?[a-z])[0-9a-zA-Z]{8,}$/; //mima123456
				// 	if (!reg.test(this.password)) {
				// 		this.$message.error("密码输入不正确");
				// 	} else if (this.password1 != this.password) {
				// 		this.$message.error('两次密码输入不一致');
				// 	} else {
				// 		this.dialogFormVisibles = false;
				// 		//重置密码
				// 		let params = {
				// 			id: this.staticId,
				// 			contactNumber: this.form.contactNumber,
				// 			contactName: this.form.contactName,
				// 		};
				// 		console.log(params);
				// 		API.unpdatePassword(params).then((res) => {
				// 			if(res.data.code==200){
				// 				console.log(res)
				// 				this.$message({
				// 					message:'重置密码成功',
				// 					type: 'success'
				// 				})
				// 				this.link=false,
				// 				this.dire=false
				// 				this.getlist()

				// 			}
				// 		});
				// 		this.form = {};
				// 		// this.password='',
				// 		this.password1=''
				// 		// this.link=false,
				// 		// this.dire=false
				// 	}
				// } else {
				this.dialogFormVisibles = false;
				let params = {
					id: this.staticId,
					contactNumber: this.form.contactNumber,
					contactName: this.form.contactName,
					// ...this.form
				};
				//  账号修改
				API.putcreateOrEditLesseeAccount(params).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							message: '修改成功',
							type: 'success'
						})
						this.getlist()
					}

				});

				// }
			},


		},
	};
</script>
<style lang='less' scoped>
	.v-model{
		background-color: white;
	}
	.MyHome {
		height: 100%;
		background-color: #ebebeb;
	}

	.rs-row {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.bg-purple-dark {
		background-color: #ffffff;
		color: black;
		font-weight: bold;
		font-size: 15px;
		padding-left: 20px;
	}

	.grid-content {
		/* border-radius: 4px; */
		height: 40px;
		line-height: 40px;
	}

	.main {
		margin: 10px;
		padding: 10px;
		background-color: #ffffff;
	}

	.main_header {
		display: flex;
		align-items: center;
	}

	.main_main {
		margin-top: 10px;
	}

	.red {
		color: cornflowerblue;
	}

	.a {
		color: red;
	}

	.rs-input {
		width: 380px;
	}

	.rs-progress {
		width: 60%;
	}

	#toggle-button {
		display: none;
	}

	.default {
		display: flex;
		justify-content: space-around;
		align-items: center;
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #fff;
		line-height: 0px;
		height: 25px;
	}

	.button-label {
		position: relative;
		display: inline-block;
		box-sizing: border-box;
		width: 50px;
		height: 25px;
		border-radius: 26px;
		background: #5867ff;

	}

	.circle {
		position: absolute;
		top: 0;
		line-height: 40px;
		text-align: center;
		transition: all 0.3s ease;
		font-size: 12px;
		color: #fff;
		width: 25px;
		height: 25px;
		background: #fff;
		border-radius: 20px;
	}

	.button-label .circle {
		right: -1px;
		left: auto;
		background: #fff;
		color: #ffffff;
	}

	#toggle-button:checked+label.button-label {}

	#toggle-button:checked+label.button-label .circle {
		right: 25px;
		left: 0px;
		background: #fff;
	}

	/* .rs-switch__label--right {
	      margin-left: 0px;
	      &.is-active {
	        color: #fff;
	        right: 24px;
	      }
		  } */
	.rs-switch {
		position: relative;
		height: 24px;
		line-height: 24px;

		&.is-checked {
			.rs-switch__core {

				// border-color: #41BDA2;
				// background-color: #41BDA2;
				&:after {
					margin-left: -22px;
				}
			}
		}

		.rs-switch__label,
		.rs-switch__core {
			width: 59px !important;
			height: 24px;
			// border-color: #ececec;
			// background-color: #ececec;
		}

		.rs-switch__core {
			border-radius: 12px;
			border: none;
			background: #f1f1f1;

			&:after {
				box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.3);
				width: 22px;
				height: 22px;
			}
		}

		.rs-switch__label.is-active {
			color: #333;
		}

		.rs-switch__label--right {
			margin-left: 0px;

			&.is-active {
				color: #fff;
				right: 24px;
			}

			position: absolute;
			right: 5px;
			top: -1px;
			color: #999;
			text-align: right;

			>span {
				font-size: 12px;
				font-weight: normal;
			}
		}
	}

	.rs-switch.is-checked {
		.el-switch__core {
			width: 59px;
			border-color: #ececec;
			background-color: #ececec;
		}
	}

	.rs-switch.is-disabled {
		opacity: 1;
	}

	.rs-switch.is-disabled .rs-switch__core,
	.rs-switch.is-disabled .rs-switch__label {
		cursor: pointer !important;
		;
	}

	/* .rs-switch__label.is-active{
		color: black;
	}
	 .rs-switch__label--right .is-active  {
	   color: #5B7BFA;
	 } */
	/*关闭时文字位置设置*/
	/* .rs-switch__label--left .is-active  {
	  color: #ccc;
	 } */
</style>
